import React from 'react';
import { LockIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroChips, images } from '../data/content';
const trust = [{
  icon: LockIcon,
  label: 'Secure payment'
}, {
  icon: DownloadIcon,
  label: 'Instant access'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function Hero() {
  return <header className="relative isolate overflow-hidden border-b border-line" data-id="element-133" data-mp="129h2fs8fj8fj">
      <img src={images.pitch} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" data-id="element-134" data-mp="127eeddqu7pdg" />
      <div className="absolute inset-0 bg-night/85" aria-hidden="true" data-id="element-135" data-mp="sa9slf0wlvx6" />
      <div className="pitch-lines absolute inset-0" aria-hidden="true" data-id="element-136" data-mp="ncq1hej3xont" />

      <div className="relative mx-auto max-w-5xl px-5 py-16 text-center sm:px-8 sm:py-20" data-id="element-137" data-mp="nekl8pin7aqb">
        <p className="font-display text-sm font-bold uppercase tracking-[0.3em] text-acid sm:text-base" data-id="element-138" data-mp="3czfny6wb6l9q">
          The Total Academy System&trade;
        </p>

        <h1 className="mx-auto mt-6 max-w-4xl font-display text-5xl font-extrabold uppercase leading-[0.9] tracking-tight text-white sm:text-6xl lg:text-7xl" data-id="element-139" data-mp="3j9u1r1hjpsmv">
          Plan your entire season of 11v11 training in less than five minutes.
        </h1>

        <p className="mx-auto mt-7 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-140" data-mp="3e9fs5f0aqamq">
          The definitive set of 6 manuals plus 5 strategic bonuses. 180+
          ready-to-run drills, a 52-week periodization matrix, and every tool
          you need to evaluate player progress — already prepared for you.
        </p>

        <img src={images.bundle} alt="The Football Method complete training system shown across desktop, laptop, tablet and phone with the five bonus guides" className="mx-auto mt-10 w-full max-w-2xl" loading="eager" data-id="element-141" data-mp="2qkwjuzh8xxun" />

        <ul className="mx-auto mt-10 flex max-w-3xl flex-wrap items-center justify-center gap-2" data-id="element-142" data-mp="2lkilya9d04ac">
          {heroChips.map(chip => <li key={chip} className="border border-line bg-panel px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-white/70" data-id="element-143" data-mp="s332b5sqsatu">
              {chip}
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-144" data-mp="dd5cymj2tf32">
          <CtaButton full label="Get the system now" data-id="element-145" data-mp="degeefp1uar0" />
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-3" data-id="element-146" data-mp="1b1fgj5yigawa">
          {trust.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.16em] text-white/45" data-id="element-147" data-mp="162c8rdr5bqkm">
              <Icon className="h-4 w-4 text-acid" aria-hidden="true" data-id="element-148" data-mp="x02zssbj059c" />
              {label}
            </li>)}
        </ul>
      </div>
    </header>;
}